"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSettingsTabContent = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var userSettings_1 = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var mapStateToProps = function (state) {
    return {
        isOpen: state.user.userSettings.isOpen,
        user: state.user.userSettings.user,
        userInfo: state.user.userSettings.userInfo,
        regions: state.user.region.list,
        validation: state.user.userSettings.validation
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    onChange: function (field) { return function (value) {
        return dispatch((0, userSettings_1.updateValue)(field, value));
    }; }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('value', 'setValue', null), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (nextProps.isOpen) {
            if (this.props !== nextProps) {
                return true;
            }
        }
        return false;
    }
}), recompose_1.pure);
var Input = (0, recompose_1.compose)((0, recompose_1.withState)('value', 'setValue', null), recompose_1.pure)(function (props) {
    var value = '';
    if (props.userInfo) {
        if (props.value === null) {
            value = props.userInfo[props.fieldName];
        }
        else {
            value = props.value;
        }
    }
    return (React.createElement(sok_ui_1.TextInput, { id: props.id, key: "input-".concat(props.fieldName), className: 'white', value: value, onChange: function (e) { return props.setValue(e.target.value); }, onBlur: function () {
            var oldValue = props.userInfo[props.fieldName] || '';
            if (value === oldValue) {
                return;
            }
            props.updateField(props.fieldName)(value);
            props.setValue(null);
        } }));
});
function getValidationError(validation, field) {
    if (validation.status === 'ERROR') {
        var errors = validation.errors[field];
        if (errors !== undefined && errors.length > 0) {
            return React.createElement("p", { className: 'form-error' }, errors[0]);
        }
    }
    return undefined;
}
exports.UserSettingsTabContent = enhance(function (props) {
    return (React.createElement("div", { className: 'user-settings-tab' },
        React.createElement(sok_ui_1.Grid.Row, null,
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                React.createElement("label", { htmlFor: 'user-settings-company' },
                    React.createElement(Icon_1.Icon, { className: "fa-building" }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/companyTitle')),
                React.createElement(sok_ui_1.TextInput, { id: 'user-settings-company', value: props.user.fold('', function (u) { return u.company || ''; }), disabled: true })),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                React.createElement("label", { htmlFor: 'user-settings-email' },
                    React.createElement(Icon_1.Icon, { className: "fa-at" }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/emailTitle')),
                React.createElement(sok_ui_1.TextInput, { id: 'user-settings-email', value: props.user.fold('', function (u) { return u.email; }), disabled: true })),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                React.createElement("label", { htmlFor: 'user-settings-firstname' },
                    React.createElement(Icon_1.Icon, { className: "fa-id-card" }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/firstNameTitle')),
                React.createElement(Input, { id: 'user-settings-firstname', fieldName: 'firstName', userInfo: props.userInfo, updateField: props.onChange }),
                getValidationError(props.validation, 'firstName')),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                React.createElement("label", { htmlFor: 'user-settings-lastname' },
                    React.createElement(Icon_1.Icon, { className: "fa-id-card" }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/lastNameTitle')),
                React.createElement(Input, { id: 'user-settings-lastname', fieldName: 'lastName', userInfo: props.userInfo, updateField: props.onChange }),
                getValidationError(props.validation, 'lastName')),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                React.createElement("label", { htmlFor: 'user-settings-title' },
                    React.createElement(Icon_1.Icon, { className: "fa-user-graduate" }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/titleTitle')),
                React.createElement(Input, { id: 'user-settings-title', fieldName: 'title', userInfo: props.userInfo, updateField: props.onChange }),
                getValidationError(props.validation, 'title')),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                React.createElement("label", { htmlFor: 'user-settings-telehone' },
                    React.createElement(Icon_1.Icon, { className: "fa-phone" }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/phoneTitle')),
                React.createElement(Input, { id: 'user-settings-telephone', fieldName: 'telephone', userInfo: props.userInfo, updateField: props.onChange }),
                getValidationError(props.validation, 'telephone')),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                ' ',
                React.createElement("label", { htmlFor: 'user-settings-street' },
                    React.createElement(Icon_1.Icon, { className: "fa-map-marker" }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/addressTitle')),
                React.createElement(Input, { id: 'user-settings-street', fieldName: 'street', userInfo: props.userInfo, updateField: props.onChange }),
                getValidationError(props.validation, 'street')),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                ' ',
                React.createElement("label", { htmlFor: 'user-settings-postal-code' },
                    React.createElement(Icon_1.Icon, { className: "fa-inbox" }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/postalCodeTitle')),
                React.createElement(Input, { id: 'user-settings-postal-code', fieldName: 'postalCode', userInfo: props.userInfo, updateField: props.onChange }),
                getValidationError(props.validation, 'postalCode')),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                ' ',
                React.createElement("label", { htmlFor: 'user-settings-city' },
                    React.createElement(Icon_1.Icon, { className: "fa-building" }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/cityTitle')),
                React.createElement(Input, { id: 'user-settings-city', fieldName: 'city', userInfo: props.userInfo, updateField: props.onChange }),
                getValidationError(props.validation, 'city')),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                React.createElement("label", { htmlFor: 'user-settings-country' },
                    React.createElement(Icon_1.Icon, { className: "fa-building" }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/countryTitle')),
                React.createElement("select", { id: 'user-settings-country', value: props.userInfo.country, onChange: function (e) {
                        return props.onChange('country')(e.target.value);
                    } },
                    React.createElement("option", null),
                    props.regions.map(function (r) { return (React.createElement("option", { key: r.code, value: r.code }, r.name)); })),
                getValidationError(props.validation, 'country')))));
});
